import pimg1 from '../images/project/1.jpg'
import pimg2 from '../images/project/2.jpg'
import pimg3 from '../images/project/3.jpg'
import pimg4 from '../images/project/4.jpg'
import pimg5 from '../images/project/2.jpg'
import pimg6 from '../images/project/3.jpg'


import p2img1 from '../images/services/img-1.jpg'
import p2img2 from '../images/services/img-2.jpg'
import p2img3 from '../images/services/img-3.jpg'
import p2img4 from '../images/services/img-4.jpg'

import p3img1 from '../images/project/5.jpg'
import p3img2 from '../images/project/6.jpg'
import p3img3 from '../images/project/7.jpg'
import p3img4 from '../images/project/8.jpg'
import p3img5 from '../images/project/9.jpg'
import p3img6 from '../images/project/10.jpg'
import p3img7 from '../images/project/11.jpg'
import p3img8 from '../images/project/12.jpg'
import p3img9 from '../images/project/13.jpg'
import p3img10 from '../images/project/14.jpg'
import p3img11 from '../images/project/15.jpg'
import p3img12 from '../images/project/16.jpg'
import p3img13 from '../images/project/17.jpg'



import pSimg1 from '../images/project-single/1.jpg'
import pSimg2 from '../images/project-single/4.jpg'
import pSimg3 from '../images/project-single/1.jpg'
import pSimg4 from '../images/project-single/4.jpg'
import pSimg5 from '../images/project-single/1.jpg'
import pSimg6 from '../images/project-single/4.jpg'





const Projects = [
    {
        id: '1',
        title: 'Home Interiors',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Beautiful Homes Start with Thoughtful Design',
        subtitle2: 'YATRI INTERIORS',
        link: 'homeinteriors',
       
        pimg3: p3img1,
       
        
    },
    {
        id: '2',
        title: 'Commercial Interiors',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Make a Statement with Smart Commercial Spaces',
        subtitle2: 'YATRI INTERIORS ',
        link: 'commercialinteriors',
       
        pimg3: p3img2,
       
        
    },
    {
        id: '3',
        title: 'Office Interiors',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Smart Office Designs for Modern Workplaces',
        subtitle2: 'YATRI INTERIORS ',
        link: 'officeinteriors',
       
        pimg3: p3img3,
      
    },
    {
        id: '4',
       title: 'Electrical & Lighting Solutions',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Safe, Efficient & Elegant Electrical Installations',
        subtitle2: 'YATRI INTERIORS ',
        link: 'electricallighting',
        
        pimg3: p3img4,
      
    },
    {
        id: '5',
        title: 'Painting Works',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'From Color Consultation to Perfect Finish',
        subtitle2: 'YATRI INTERIORS ',
        link: 'paintingwork',
       
        pimg3: p3img5,
        
    },
    {
        id: '6',
        title: 'Plumbing Works',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Professional Plumbing That Flows Right',
        subtitle2: 'YATRI INTERIORS ',
        link: 'plumbingwork',
        pimg3: p3img6,
        
    },

     {
        id: '7',
        title: 'Renovation Works',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Give Your Old Space a Fresh New Life',
        subtitle2: 'YATRI INTERIORS ',
        link: 'renovationwork',
         pimg3: p3img7,
        
    },

     {
        id: '8',
        title: 'Carpentry Works',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: 'Custom Carpentry Tailored to Your Space',
        subtitle2: 'YATRI INTERIORS ',
        link: 'Carpentryworks',
         pimg3: p3img8,
        
    },

     {
        id: '9',
        title: '',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: '',
        subtitle2: 'YATRI INTERIORS ',
        link: '',
         pimg3: p3img9,
        
    },
     {
        id: '10',
        title: '',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: '',
        subtitle2: 'YATRI INTERIORS ',
        link: '',
         pimg3: p3img10,
        
    },

    {
        id: '11',
        title: '',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: '',
        subtitle2: 'YATRI INTERIORS ',
        link: '',
         pimg3: p3img11,
        
    },
     {
        id: '12',
        title: '',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: '',
        subtitle2: 'YATRI INTERIORS ',
        link: '',
         pimg3: p3img12,
        
    },
     {
        id: '13',
        title: '',
        title2: 'YATRI INTERIORS',
        title3: '',
        subtitle: '',
        subtitle2: 'YATRI INTERIORS ',
        link: '',
         pimg3: p3img13,
        
    },



]
export default Projects;






